import Slack from './SlackChannel'
import Email from './EmailChannel'
import Mailjet from './MailjetChannel'

export const channelLookup = {
  'Channels::SlackChannel': Slack,
  'Channels::EmailChannel': Email,
  'Channels::MailjetChannel': Mailjet,
}

export default class ChannelTypes {
  static Slack = Slack
  static Email = Email
  static Mailjet = Mailjet
}
